// 滚动进入视口时给元素加 content-center 类触发进场动画。
// 使用方式：组件 mixins: [scrollReveal]，并声明 revealSelectors 选项（querySelectorAll 选择器字符串）。
export default {
	methods: {
		scrollLoadEvent() {
			const selectors = this.$options.revealSelectors
			if (!selectors) return
			const contents = document.querySelectorAll(selectors)
			const targetValue = window.innerHeight
			contents.forEach(function(content) {
				const contentTop = content.getBoundingClientRect().top
				if (contentTop <= targetValue) {
					content.classList.add('content-center')
				}
			})
		},
		throttle(fn, milliseconds = 200, context) {
			let lastEventTimestamp = null
			return function(...args) {
				const self = context || this
				const now = Date.now()
				if (!lastEventTimestamp || now - lastEventTimestamp >= milliseconds) {
					fn.apply(self, args)
					lastEventTimestamp = now
				}
			}
		}
	},
	mounted() {
		this.scrollLoadEvent()
		window.addEventListener('scroll', this.throttle(this.scrollLoadEvent, 200), false)
	}
}
